import { render, staticRenderFns } from "./MergeRule.vue?vue&type=template&id=7dd46960"
import script from "./MergeRule.vue?vue&type=script&lang=js"
export * from "./MergeRule.vue?vue&type=script&lang=js"
import style0 from "./MergeRule.vue?vue&type=style&index=0&id=7dd46960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports